// removed by extract-text-webpack-plugin
module.exports = {"ShareholdersContainer":"ShareholdersContainer-3quxxqxszvmh7upqtem3rtu5pa5hngu4pg9w54eefkscpshe73rpn7hshu7x4xvn8hbeaudj76u57pdmuwxrqkdfywxcwu4d4xdcucy"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Shareholders/ShareholdersView.module.scss
// module id = 1718
// module chunks = 0